<template>
  <div class="d-flex flex-column flex-root">
    <CatalogoDigitalOrderPoller
      v-if="isAuthenticated && empresaId"
      :key="empresaId"
      :empresa-id="empresaId"
    />
    <router-view />
  </div>
</template>

<style lang="scss">
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "~perfect-scrollbar/css/perfect-scrollbar.css";
@import "~socicon/css/socicon.css";
@import "~animate.css";
@import "~@fortawesome/fontawesome-free/css/all.css";
@import "~line-awesome/dist/line-awesome/css/line-awesome.css";
@import "assets/plugins/flaticon/flaticon.css";
@import "assets/plugins/flaticon2/flaticon.css";
@import "assets/plugins/keenthemes-icons/font/ki.css";
@import "assets/sass/style.vue";
</style>

<script>
import { mapGetters } from "vuex";
import CatalogoDigitalOrderPoller from "@/modules/CatalogoDigital/components/CatalogoDigitalOrderPoller.vue";

export default {
  name: "nuts",
  components: { CatalogoDigitalOrderPoller },
  computed: {
    ...mapGetters(["isAuthenticated", "empresaContexto"]),
    empresaId() {
      return Number(this.empresaContexto?.id_empresa || 0);
    },
  },
};
</script>
